import { OfferColumnConfigurationsLoaded } from "./offers.actions";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import OfferColumnConfigurations from "./offerColumnConfigurations";
import { ColumnCustomization } from "common/agGrid/columnCustomization";
import { defaultOfferColumns } from "./OfferListColumns";

export default class OfferColumnConfigurationsReducer extends ReducerBase<OfferColumnConfigurations> {

    constructor() {
        super();
        this.addHandler(OfferColumnConfigurationsLoaded.EventName, this.handleConfigLoaded);
    }

    handleConfigLoaded(state: OfferColumnConfigurations = initialState.offerColumnConfigurations, event: OfferColumnConfigurationsLoaded): OfferColumnConfigurations {
        
        const getCols = (getter: (c: OfferColumnConfigurations) => ColumnCustomization): ColumnCustomization => {
            let customization = getter(event.columnConfigs)

            if (customization.visibleColumns == null || customization.visibleColumns.length === 0) {
                customization = getter(defaultOfferColumns);
            }

            return customization;
        }

        return {
            working: getCols(m => m.working),
            pending: getCols(m => m.pending),
            filled: getCols(m => m.filled),
            cancelled: getCols(m => m.cancelled),
            expired: getCols(m => m.expired),
        }
    }

    handleDefault(state: OfferColumnConfigurations = initialState.offerColumnConfigurations) {
        return state;
    }
}
